export const phoneVerificationCopy = {
  legal:
    'By submitting your phone number, you agree to receive time critical notifications via SMS from Inspiren. Message and data rates may apply.',
};
